import type { CSSProperties, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface NotificationCardProps {
  icon: ReactNode
  title: string
  /** Info while learning, success once done; the tint rises from the bottom edge. */
  tint: 'learning' | 'ready'
  children: ReactNode
  className?: string
}

// Opaque: the card floats over scrolling Home content. The tint is layered on
// the panel background rather than blended with whatever is behind it.
const TINT_STYLE: Record<NotificationCardProps['tint'], CSSProperties> = {
  learning: {
    backgroundImage:
      'linear-gradient(to top, oklch(from var(--info) l c h / 16%) 18%, oklch(from var(--info) l c h / 4%) 37%), linear-gradient(var(--background), var(--background))',
  },
  ready: {
    backgroundImage:
      'linear-gradient(to top, oklch(from var(--success) l c h / 6%) 18%, oklch(from var(--success) l c h / 20%) 37%), linear-gradient(var(--background), var(--background))',
  },
}

export function NotificationCard({ icon, title, tint, children, className }: NotificationCardProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={twMerge('shadow-xs relative flex w-full flex-col gap-3 rounded-xl border p-4', className)}
      style={TINT_STYLE[tint]}
    >
      <div className="flex items-center gap-2">
        {icon}
        <p className="type-ui-sm text-foreground min-w-0 flex-1 font-medium">{title}</p>
      </div>
      {children}
    </div>
  )
}
